<template>
    <div :style="`min-width:${barChartVisitacao.chartData.labels.length * 8}px;max-width:100%;`">
        <bar-chart id="bar-chart-visitacao" :height="250" :chart-data="barChartVisitacao.chartData" :extra-options="barChartVisitacao.extraOptions">
        </bar-chart>
    </div>
</template>

<script>
const defaultObject = {
    chartData: {
        labels: [],
        datasets: [{
            data: [],
            backgroundColor: [],
            barThickness: 8,
            maxBarThickness: 30,
        }],
    },
    extraOptions: {
        legend: {
            display: false
        }
    }
}

import BarChart from '@/components/Charts/BarChart'

export default {
    component: 'BarChartVisitacao',

    components: {
        BarChart,
    },

    props: {
        height: {
            type: Number,
            default: 250
        },

        fetchProgress: {
            type: Number,
            default: 0 | 100
        },

        chartVisitacaoView: {
            type: String,
            default: "city",
        },

        defaultBarThickness: {
          type: Number,
          default: 8,
        },

        maxBarThickness: {
            type: Number,
            default: 30,
        },

        transformedItemsArray: {
            type: Array,
            default: [],
        },
    },

    data: () => {
        return {
            defaultChart: defaultObject,
        }
    },

    computed: {
        barChartVisitacao() {
            if(this.fetchProgress > 0 && this.fetchProgress < 100){
                this.defaultChart = defaultObject
                return this.defaultChart
            }

            else if(this.fetchProgress == 0 || this.fetchProgress == 100){
                var labels = ['--']
                var valuesLabels = [0]

                if (this.chartVisitacaoView == 'country') {
                    var dados = this.groupBy(this.transformedItemsArray, el => el.billing.country)

                    var labels = dados.map(function (val, idx) {
                        var country = val[0]
                        return country == null || country.length == 0 ? '--' : country;
                    })

                    labels = labels.filter((v, i, a) => a.indexOf(v) === i)

                    var valores = dados.map(function (val, idx) { return val[1]; })
                    var valuesLabels = new Array(labels.length).fill(0)

                    valores.map(function (value, index) {
                        value.map(function (val, idx) {
                            var country = val.billing.country
                            var indexCountry = labels.findIndex(el => el == country)

                            if(indexCountry < 0) { indexCountry = labels.findIndex(el => el == '--') }
                            valuesLabels[indexCountry] = valuesLabels[indexCountry] + Number(val.people.tableText.count)
                        })
                    })
                }

                if (this.chartVisitacaoView == 'state') {
                    var dados = this.groupBy(this.transformedItemsArray, el => el.billing.state)

                    var labels = dados.map(function (val, idx) {
                        var state = val[0]
                        return state == null || state.length == 0 ? '--' : state;
                    })

                    labels = labels.filter((v, i, a) => a.indexOf(v) === i)

                    var valores = dados.map(function (val, idx) { return val[1]; })
                    var valuesLabels = new Array(labels.length).fill(0)

                    valores.map(function (value, index) {
                        value.map(function (val, idx) {
                            var state = val.billing.state
                            var indexState = labels.findIndex(el => el == state)

                            if(indexState < 0) { indexState = labels.findIndex(el => el == '--') }
                            valuesLabels[indexState] = valuesLabels[indexState] + Number(val.people.tableText.count)
                        })
                    })
                }

                if (this.chartVisitacaoView == 'city') {
                    var dados = this.groupBy(this.transformedItemsArray, el => el.billing.city)

                    let labels = dados.map(function (value, index) {
                        return value[1].map(function(val, idx){
                            var state = val.billing.state

                            if (value[0] == null || value[0].length == 0 || value[0] == 0 || value[0].includes('ão informado') || state == null || state.length == 0) {
                                return "--"
                            }
                            else {
                                var cityState = value[0] + ' - ' + state
                                return cityState;
                            }
                        })
                    })[0]

                    labels = labels.filter((el, idx) => { return labels.indexOf(el) === idx });

                    var valores = dados.map(function (val, idx) { return val[1]; })
                    var valuesLabels = new Array(labels.length).fill(0)

                    valores.map(function (value, index) {
                        value.map(function (val, idx) {
                            var cityState = val.billing.city + ' - ' + val.billing.state
                            var indexCity = labels.findIndex(el => el == cityState)

                            if(indexCity < 0) { indexCity = labels.findIndex(el => el == '--') }
                            valuesLabels[indexCity] = valuesLabels[indexCity] + Number(val.people.tableText.count)
                        })
                    })
                }

                this.defaultChart = {
                    chartData: {
                        labels: labels,
                        datasets: [{
                            data: valuesLabels,
                            backgroundColor: this.colors,
                            barThickness: this.defaultBarThickness,
                            maxBarThickness: this.maxBarThickness,
                        }],
                    },
                    extraOptions: {
                        legend: {
                            display: false
                        }
                    }
                }
                return this.defaultChart;
            }
        }
    },

    methods:{
        //METHOD TO GROUP BY KEYGETTER.
        //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);

                if (!collection) { map.set(key, [item]); }
                else { collection.push(item); }
            });
            return Array.from(map);
        },
    }
}
</script>
